import { useEffect, useRef, useState } from "react";
import shredieckNotes from "./shredieckNotes";

export default function ShredieckScroller({

  notes = shredieckNotes,

  speed = 1200,

  maxVisible = 18,

}) {

  const containerRef = useRef(null);

  const [visibleNotes, setVisibleNotes] =
    useState([]);

  const noteId = useRef(0);

  const currentIndex = useRef(0);

  useEffect(() => {

    if (!notes.length) return;

    let interval;

    function spawnNote() {

      // End of exercise
      if (
        currentIndex.current >= notes.length
      ) {
        clearInterval(interval);
        return;
      }

      const note = {

        id: noteId.current++,

        value:
          notes[currentIndex.current],

      };

      currentIndex.current++;

      setVisibleNotes(prev => {

        const next = [...prev, note];

        // VARIABLE MAX NOTES
        if (next.length > maxVisible) {
          next.shift();
        }

        return next;
      });

      // Remove after full travel
      setTimeout(() => {

        setVisibleNotes(prev =>
          prev.filter(
            n => n.id !== note.id
          )
        );

      }, speed * maxVisible);

    }

    

    interval = setInterval(
      spawnNote,
      speed
    );


    return () => {
      clearInterval(interval);
    };

  }, [notes, speed, maxVisible]);

  return (

    <div
      ref={containerRef}
      className="shradieckContainer"
    >
      <div id="score">0</div>
      {visibleNotes.map(note => (

        <div
          key={note.id}

          className="shredNote"

          style={{

            animationDuration:
              `${speed * maxVisible}ms`,
          }}
        >

          <div
            className={
              note.value.charAt(0) == 5
                ? 'up shred ' +
                  note.value.charAt(1)+' acc'+note.value.charAt(2)

                : note.value.charAt(0) == 6

                ? 'upup shred ' +
                  note.value.charAt(1)+' acc'+note.value.charAt(2)

                : 'shred ' +
                  note.value.charAt(1)+' acc'+note.value.charAt(2)
            }
          >
<img src='/cherry.png'/>
            <div className='liness'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>

          </div>

        </div>

      ))}

    </div>
  );
}